export default "__VITE_ASSET__0teEYkWV__"